// packages
const { h, Component } = require('preact');
const journalize = require('journalize');
import { formatDate, formatNumberAnnotation, formatNumberPct, formatCountiesTitle, formatNumberWithCommas } from '../../utils/utils';
import { geoMercator, geoPath } from 'd3';

// components

// internal
import mapData from '../../../../data/texas-boundary.json';
import data from '../../../../data/data.json';

class CountyInfo extends Component {
  constructor() {
    super();

    this.state = {}
  }

  render() {
    console.log('CountyInfo render called with county:', this.props.county);
    const countyData2026 = data['2026-county-turnout'].find(d => d.County == this.props.county);
    const countyData2024 = data['2024-county-turnout'].find(d => d.County == this.props.county);
    
    console.log('CountyInfo found data:', { countyData2026, countyData2024 });
    
    if (!countyData2026) {
      return <div>County data not found for {this.props.county}</div>;
    }
    
    const formattedCounty = formatCountiesTitle(this.props.county);
    const regVoters = formatNumberWithCommas(+countyData2026.registered);
    const regVotersMargin = formatNumberWithCommas(Math.abs(+countyData2026.registered - +countyData2024.registered));
    const isIncreased = +countyData2026.registered - +countyData2024.registered > 0 ? "an increase" : "a decrease";

    const projection = geoMercator()
      .fitSize([90, 90], mapData);
    const path = geoPath(projection);

    const countyMapData = data['counties'].find(d => d.county == this.props.county);
    const coordinates = [countyMapData.long, countyMapData.lat];

    return (
      <div class="county-info">
        <div class="county-description">
          <h1>
            {formattedCounty}
            <svg
              width="100"
              height="100"
            >
              <g transform="translate(5, 5)">
                <path
                  d={path(mapData.features[0])}
                  fill="lightgray"
                ></path>
                <circle
                  cx={projection(coordinates)[0]}
                  cy={projection(coordinates)[1]}
                  r="5"
                ></circle>
              </g>
            </svg>
          </h1>
          <p class="t-copy">There are <span>{regVoters}</span> registered voters in {formattedCounty}, {isIncreased} of <span>{regVotersMargin}</span> voters from 2024.</p>
        </div>
      </div>
    )
  }
}

export default CountyInfo;
